import { render, staticRenderFns } from "./ServerCard.vue?vue&type=template&id=58388930&scoped=true&"
import script from "./ServerCard.vue?vue&type=script&lang=js&"
export * from "./ServerCard.vue?vue&type=script&lang=js&"
import style0 from "./ServerCard.vue?vue&type=style&index=0&id=58388930&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58388930",
  null
  
)

export default component.exports